import { api } from "../api/client";
import { mockAvailability } from "../lib/mockInventory";

// Availability lookup. Reads from a custom record (not from the NetSuite
// item record) so the B2B exposes only its own subset of inventory in a
// single fulfilment location. The same record is decremented when B2B
// orders are placed.
//
// Falls back to mock data when the API isn't reachable. Remove the mock
// fallback (and src/lib/mockInventory.js) once the inventory handler ships.
async function withMock(promise, fallback) {
  try {
    const out = await promise;
    if (out && (out.available != null || out.sku)) return out;
    return fallback();
  } catch {
    return fallback();
  }
}

export const InventoryController = {
  get(sku, mode) {
    return withMock(
      api.getAvailability ? api.getAvailability(sku, mode) : Promise.resolve(null),
      () => mockAvailability(sku, mode)
    );
  },
};
